import { useState, useRef, useEffect } from "react";

export const useSpeechRecognition = (t) => {
  const [isWelcomeListening, setIsWelcomeListening] = useState(false);
  const welcomeRecognitionRef = useRef(null);

  const toggleWelcomeSpeech = () => {
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) {
      alert(
        t
          ? t("Pages.Chatbot.SpeechNotSupported")
          : "ميزة التعرف على الصوت غير مدعومة في متصفحك. يرجى استخدام Chrome أو Edge."
      );
      return;
    }

    if (welcomeRecognitionRef.current) {
      welcomeRecognitionRef.current.stop();
      setIsWelcomeListening(false);
      welcomeRecognitionRef.current = null;
      return;
    }

    const recognition = new SpeechRecognition();
    recognition.lang = "ar-EG";
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;

    recognition.onstart = () => {
      setIsWelcomeListening(true);
    };

    recognition.onresult = (event) => {
      const speechToText = event.results[0][0].transcript;
      const inputEl = document.querySelector(".welcome-search-input");
      if (inputEl) {
        inputEl.value = (inputEl.value + " " + speechToText).trim();
      }
    };

    recognition.onerror = (event) => {
      console.error("Speech recognition error", event.error);
      setIsWelcomeListening(false);
      welcomeRecognitionRef.current = null;
    };

    recognition.onend = () => {
      setIsWelcomeListening(false);
      welcomeRecognitionRef.current = null;
    };

    welcomeRecognitionRef.current = recognition;
    recognition.start();
  };

  useEffect(() => {
    return () => {
      if (welcomeRecognitionRef.current) {
        welcomeRecognitionRef.current.stop();
      }
    };
  }, []);

  return { isWelcomeListening, toggleWelcomeSpeech };
};
